import NiceSelect from 'nice-select2';

import { BaseComponent } from '../core/BaseComponent.js';

export class NiceSelectComponent extends BaseComponent {
    constructor(options = {}) {
        super(document, options);
        this.selector = options.selector || 'select.ds-nice-select';
    }

    init() {
        this.initSelects();
        new MutationObserver(() => this.initSelects()).observe(document.body, {
            childList: true,
            subtree: true,
        });
        return this;
    }

    initSelects() {
        document.querySelectorAll(this.selector).forEach(select => {
            if (!select.hasAttribute('data-nice-select')) {
                select.setAttribute('data-nice-select', 'true');
                const placeholder = select.options[0]?.text || '';
                new NiceSelect(select, { searchable: false, placeholder });
                setTimeout(() => this.addLenisPrevent(), 100);
            }
        });
        this.addLenisPrevent();
    }

    addLenisPrevent() {
        document.querySelectorAll('.nice-select-dropdown').forEach(dropdown => {
            if (!dropdown.hasAttribute('data-lenis-prevent')) {
                dropdown.setAttribute('data-lenis-prevent', '');
            }
        });
    }
}
